import { defineMessage, AudienceFilter, defineTopic } from 'magpie-lib/models';
import * as t from 'ts-schema';

const syncedStateMessage = defineMessage({
  type: `@@video-components-external/state/synced-state` as const,
  payloadSchema: t.object({
    state: t.any,
    stateName: t.string,
  }),
});

const syncedFromLeaderStateMessage = defineMessage({
  type: `@@video-components-external/state/synced-from-leader-state` as const,
  payloadSchema: t.object({
    state: t.any,
    stateName: t.string,
  }),
});

// COMMANDS
const syncFromLeaderStateCommand = defineMessage({
  type: `@@video-components-external/state/sync-from-leader-state` as const,
  reply: syncedFromLeaderStateMessage,
  payloadSchema: t.object({
    stateName: t.string,
  }),
});

export const StateMessages = {
  syncedStateMessage,
  syncedFromLeaderStateMessage,
};

export const StateCommands = {
  syncFromLeaderStateCommand,
};

export const stateTopicDef = defineTopic({
  name: `@@video-components-external/state/` as const,
  messages: [...Object.values(StateMessages), ...Object.values(StateCommands)],
  enableRuntimeValidation: false,
  audience: AudienceFilter.builder().excludeSelf().build(),
});
